import { REVIEW_STATUS } from '@/constants/reviewStatus'
export default {
  computed: {
    currentLoggedUser () {
      return this.$store.getters['UsersStore/userLogged']
    },
    transactionReviewUserTasks () {
      return this.transaction?.reviewUserTasks || []
    },
    userCanReviewExpense () {
      const userInReviewUserTask = this.transactionReviewUserTasks.find(el => el.user.id === this.currentLoggedUser.id)

      if (userInReviewUserTask) {
        return userInReviewUserTask.canReviewNextStep && userInReviewUserTask.pending
      }
      return false
    },

    isInExpensesSection () {
      const expenseSectionsNames = ['my_pending_reimbursements', 'my_history_reimbursements', 'my_charged_transactions', 'my_authorizations_transactions', 'my_declined_transactions']
      return expenseSectionsNames.includes(this.$route.name)
    },
    transactionIsCompleted () {
      return this.transaction.isCompleted
    },
    transactionIsApproved () {
      return this.transaction.reviewStatus.code === REVIEW_STATUS.APPROVED
    },
    transactionIsPersonalExpense () {
      return this.transaction.isPersonalExpense && this.transactionIsApproved
    },
    transactionIsAccounted () {
      return !!this.transaction.accountedAt
    },
    transactionIsDraft () {
      return this.transaction.reviewStatus.code === REVIEW_STATUS.DRAFT
    },
    transactionIsAwaitingReview () {
      return this.transaction.reviewStatus.code === REVIEW_STATUS.AWAITING_REVIEW || this.transaction.reviewStatus.code === REVIEW_STATUS.OFFICE_FLOW_REVISION
    },
    transactionIsDenied () {
      return this.transaction.status.code === 'KO'
    },
    transactionIsRejected () {
      return this.transaction.reviewStatus.code === REVIEW_STATUS.CANCELLED
    },
    transactionIsAuthorization () {
      return (
        this.transaction?.type?.code === 'NORMAL' && this.transaction.amount === 0
      )
    },
    transactionInOfficeFlowRevision () {
      return this.transaction.reviewStatus.code === REVIEW_STATUS.OFFICE_FLOW_REVISION
    },
    transactionIsProcessing () {
      return this.transaction?.processing
    },
    transactionStatusLabel () {
      if (this.transactionIsProcessing) {
        return this.$t('transactions_status__PROCESSING')
      }
      if (this.transactionIsAuthorization) {
        return this.$t('transactions_status__AUTHORIZATION')
      }
      if ((this.isAdmin || this.isBookKeeper) && this.transactionIsAccounted) {
        return this.$t('transaction_status__IS_ACCOUNTED')
      }
      if (this.transactionIsPersonalExpense) {
        return this.$t('transactions_status_personal_expense')
      }
      if (this.transaction.status.code === 'KO') {
        return this.$t('transactions_status__KO')
      }

      if (this.transactionIsApproved) {
        return this.$t('transactions_review_status__APPROVED')
      }
      if (this.transactionIsRejected) {
        return this.$t('transactions_review_status__CANCELLED')
      }
      if (this.transactionIsDraft) {
        return this.$t('transactions_review_status__DRAFT')
      }

      if ((this.transactionIsAwaitingReview || this.transactionInOfficeFlowRevision) && this.transactionIsCompleted) {
        if (this.userCanReviewExpense && this.isInExpensesSection) {
          return this.$t('transactions_review_status_send_for_review')
        }
        if (this.userCanReviewExpense && !this.isInExpensesSection) {
          return this.$t('transactions_review_status__AWAITING_REVIEW')
        }
        if (!this.userCanReviewExpense) {
          return this.$t('transactions_review_status_send_for_review')
        }
      }

      if (!this.transactionIsCompleted && this.transactionIsAwaitingReview) {
        return this.$t('transactions_categorize_status__INCOMPLETED_large')
      }

      if (this.transactionIsCompleted) {
        return this.$t('transactions_categorize_status__COMPLETED')
      }
    },
    transactionStatusLabelClass () {
      if (this.transactionIsProcessing) {
        return 'pending' // TBC
      }
      if (this.transactionIsAuthorization) {
        return 'status--active'
      }
      if (this.transaction.status.code === 'KO') {
        return 'status--red'
      }

      if ((this.isAdmin || this.isBookKeeper) && this.transactionIsAccounted) {
        return 'status--accounted'
      }
      if (this.transactionIsPersonalExpense) {
        return 'status--red'
      }

      if (this.transactionIsApproved) {
        return 'status--approved'
      }

      if (this.transactionIsRejected) {
        return 'status--red'
      }

      if (this.transactionIsDraft) {
        return 'status--warning'
      }

      if ((this.transactionIsAwaitingReview || this.transactionInOfficeFlowRevision) && this.transactionIsCompleted) {
        if (this.userCanReviewExpense && this.isInExpensesSection) {
          return 'status--active'
        }
        if (this.userCanReviewExpense && !this.isInExpensesSection) {
          return 'status--warning'
        }
        if (!this.userCanReviewExpense) {
          return 'status--active'
        }
      }

      if (this.transactionIsAwaitingReview && this.transactionIsCompleted) {
        return this.isInExpensesSection
          ? 'status--active'
          : 'status--warning'
      }

      if (!this.transactionIsCompleted && this.transactionIsAwaitingReview) {
        if (this.$route.name.includes('my_')) return 'status--warning'
        return 'status--incompleted'
      }

      if (this.transactionIsCompleted) {
        return 'status--active'
      }
    },
    transactionLockedByIcon () {
      if (this.transactionIsAuthorization) {
        return 'icon-lock-active'
      }
      if (this.transaction.status.code === 'KO') {
        return 'icon-lock-red'
      }

      if ((this.isAdmin || this.isBookKeeper) && this.transactionIsAccounted) {
        return 'icon-lock-account'
      }

      if (this.transactionIsPersonalExpense) {
        return 'icon-lock-red'
      }

      if (this.transactionIsApproved) {
        return 'icon-lock-approved'
      }

      if (this.transactionIsRejected) {
        return 'icon-lock-red'
      }

      if (this.transactionIsDraft) {
        return 'icon-lock-warning'
      }

      if ((this.transactionIsAwaitingReview || this.transactionInOfficeFlowRevision) && this.transactionIsCompleted) {
        if (this.userCanReviewExpense && this.isInExpensesSection) {
          return 'icon-lock-active'
        }
        if (this.userCanReviewExpense && !this.isInExpensesSection) {
          return 'icon-lock-warning'
        }
        if (!this.userCanReviewExpense) {
          return 'icon-lock-active'
        }
      }

      if (this.transactionIsAwaitingReview && this.transactionIsCompleted) {
        return this.isInExpensesSection
          ? 'icon-lock-active'
          : 'icon-lock-warning'
      }

      if (!this.transactionIsCompleted && this.transactionIsAwaitingReview) {
        if (this.$route.name.includes('my_')) return 'icon-lock-warning'
        return 'icon-lock-incompleted'
      }

      if (this.transactionIsCompleted) {
        return 'icon-lock-active'
      }
    }
  }
}
